import Servico from './Servico'

class UnidadeServico extends Servico {
  constructor() {
    super('unidade')
  }
}

export default UnidadeServico
